import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DefaultButton } from "@fluentui/react";
import { useFeatureFlag } from "../hooks/useFeatureFlag";
import './SharedGrid.css';
const addIcon = { iconName: "Add" };
const editIcon = { iconName: "Edit" };
const LandingSection = ({ onNewPlacement, onUpdatePlacement }) => {
    const showNewPlacement = useFeatureFlag('newPlacement');
    const showUpdatePlacement = useFeatureFlag('updatePlacement');
    return (_jsx("div", { className: "ms-Grid", dir: "ltr", id: "maindiv", children: _jsx("div", { className: "ms-Grid savesection", children: _jsxs("div", { className: "ms-Grid-row attachmentdiv", children: [showNewPlacement && (_jsx("div", { className: "ms-Grid-col ms-sm3 ms-md2 ms-lg2 savebuttonmargin-placement", children: _jsx(DefaultButton, { iconProps: addIcon, text: "New Placement", type: "submit", onClick: onNewPlacement, styles: {
                                root: {
                                    width: "100%",
                                    height: 40,
                                    justifyContent: "flex-start",
                                    paddingLeft: 4,
                                },
                                label: {
                                    textAlign: "left",
                                    width: "100%",
                                    fontWeight: "bold",
                                    fontSize: 12,
                                    color: "#242424",
                                },
                                icon: {
                                    backgroundColor: "#EBF3FC",
                                    padding: 7,
                                    borderRadius: 1,
                                    color: "#242424",
                                    fontWeight: "bold",
                                    fontSize: 10,
                                    width: 15,
                                    height: 15,
                                },
                            } }) })), showNewPlacement && showUpdatePlacement && _jsx("br", {}), showUpdatePlacement && (_jsx("div", { className: "ms-Grid-col ms-sm3 ms-md2 ms-lg2 savebuttonmargin-placement", children: _jsx(DefaultButton, { iconProps: editIcon, text: "Update Placement / Submission", type: "submit", onClick: onUpdatePlacement, styles: {
                                root: {
                                    width: "100%",
                                    height: 40,
                                    justifyContent: "flex-start",
                                    paddingLeft: 4,
                                },
                                label: {
                                    textAlign: "left",
                                    width: "100%",
                                    fontWeight: "bold",
                                    fontSize: 12,
                                    color: "#242424",
                                },
                                icon: {
                                    backgroundColor: "#EBF3FC",
                                    padding: 7,
                                    borderRadius: 1,
                                    color: "#242424",
                                    fontWeight: "bold",
                                    fontSize: 10,
                                    width: 15,
                                    height: 15,
                                },
                            } }) }))] }) }) }));
};
export default LandingSection;
